import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import images from "../../../images";
import Button from "../../../components/common/Button/Button";
import {
  cn,
  formatDateToFakeMicroUTC,
  getDayCountdown,
  getJoinQuestCountdown,
  getTimeRemaining,
} from "../../../Utils/helper/index";
import { useTranslation } from "react-i18next";
import Requirement from "../../../components/common/Requirement/Requirement";
import Status from "../../../components/common/Status/Status";
import QuestStatBox from "../../../components/common/QuestStatBox/QuestStaBox";
import SlideImage from "../../../components/common/SlideShowImage/SlideImage";
import Timer from "../DetailMultipleChoice/Timer";

const TaskQuest = ({
  requirement,
  handleTaskQuest,
  token,
  estTime,
  expireIn,
  slotAvailable,
  consumerStatus,
  businessAvatar,
  questType,
  locationId,
  questName,
  isEnable,
  expireTime,
  numberHandleByQuota,
  quotaCount,
  quotaType,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const fileName = businessAvatar?.split("/").pop();
  const isIneligible = consumerStatus === "INELIGIBLE";
  const slotLeft = Math.round(slotAvailable / 10);
  const [countdown, setCountdown] = useState(getJoinQuestCountdown());
  const [countdownDay, setCountdownDay] = useState(getDayCountdown());

  const calculateRemainingTime = () => {
    const now = new Date();
    const nowUTCISOString = formatDateToFakeMicroUTC(now);
    const expiredDate = expireIn ? new Date(expireIn.slice(0, 23)) : null;
    const nowDate = new Date(nowUTCISOString.slice(0, 23));
    const diffMs = expiredDate ? expiredDate.getTime() - nowDate.getTime() : 0;
    return Math.round(diffMs / 1000);
  };

  const initialRemainingTime = calculateRemainingTime();
  const [remainingTime, setRemainingTime] = useState(
    initialRemainingTime > 0 ? initialRemainingTime : null
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown(getJoinQuestCountdown());
      setCountdownDay(getDayCountdown());
    }, 1000); // Update every second
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    if (initialRemainingTime <= 0 || consumerStatus !== "PAUSED_QUEST") {
      setRemainingTime(null);
      return;
    }

    const timer = setInterval(() => {
      setRemainingTime((prevTime) => {
        if (prevTime === null || prevTime <= 1) {
          clearInterval(timer);
          return null;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, [initialRemainingTime, consumerStatus]);

  const timeInfo = useMemo(
    () => getTimeRemaining(expireTime, t),
    [expireTime, t]
  );

  const handleBackNavigation = () => {
    const searchParams = new URLSearchParams(location.search);
    const searchQuery = searchParams.get("search");
    const fromSource = searchParams.get("from");
    if (fromSource === "home") {
      if (searchQuery) {
        navigate(`/?search=${encodeURIComponent(searchQuery)}`);
      } else {
        navigate("/");
      }
    } else {
      if (locationId) {
        navigate(`/quest/location/${locationId}`);
      } else {
        navigate("/", { replace: true });
      }
    }
  };

  const getButtonConfig = () => {
    if (slotAvailable === 0 && consumerStatus === "NOT_STARTED") {
      return {
        text: t("quest.questDetails.noSlotAvailable"),
        color: "bg-gray-300",
        textColor: "text-gray-500",
        disabled: true,
      };
    }
    switch (consumerStatus) {
      case "NOT_STARTED":
        return {
          text: t("quest.taskQuest.takeQuest"),
          color: "bg-[#253FF6]",
          textColor: "text-white",
          disabled: false,
        };
      case "PAUSED_QUEST":
        return {
          text: t("quest.taskQuest.continue"),
          color: "bg-[#EF4056]",
          textColor: "text-white",
          disabled: false,
        };
      case "SAVE_QUEST":
        return {
          text: t("quest.taskQuest.reJoinQuest"),
          color: "bg-[#00B88C]",
          textColor: "text-white",
          disabled: false,
        };
      case "INELIGIBLE":
        return {
          text: t("quest.taskQuest.Ineligible"),
          color: "bg-[#E9E6E4]",
          textColor: "text-[#A0A0A0]",
          disabled: true,
        };
      case "COMPLETED":
        return {
          text: t("quest.taskQuest.done"),
          color: "bg-gray-300",
          textColor: "text-gray-500",
          disabled: true,
        };
      case "REVIEWING":
        return {
          text: t("quest.taskQuest.reviewing"),
          color: "bg-gray-300",
          textColor: "text-gray-500",
          disabled: true,
        };
      default:
        return {
          text: t("quest.taskQuest.takeQuest"),
          color: "bg-[#253FF6]",
          textColor: "text-white",
          disabled: false,
        };
    }
  };

  const { text, color, textColor, disabled } = getButtonConfig();

  // console.log("quotaCount", quotaCount, numberHandleByQuota);

  return (
    <div className="flex flex-col justify-center w-full bg-white ">
      <div className="w-full relative rounded-md">
        <SlideImage
          imageHeight="h-[100px]"
          applyImageOverlay={!isEnable}
          isIneligible={!isEnable}
          illustration={
            questType === "INTRODUCE"
              ? isEnable
                ? images.Introduce
                : images.IntroduceDisable
              : questType === "USER_JOURNEY"
              ? isEnable
                ? images.ExperienceTRail
                : images.ExperienceTrailDisable
              : questType === "PULSE_CHECK"
              ? isEnable
                ? images.VibeCheck
                : images.VibeCheckDisable
              : questType === "SNAP"
              ? isEnable
                ? images.Snap
                : images.SnapDisable
              : ""
          }
        />
        <div
          className="absolute top-[30px] left-8 cursor-pointer z-50"
          onClick={handleBackNavigation}
        >
          <img src={images.LeftArrowNew} alt="" className="w-6 h-6" />
        </div>
        <div
          className={`flex absolute ${
            consumerStatus === "NOT_STARTED" ? "top-[68px]" : "top-[68px]"
          } left-8 flex-col self-start text-xs font-bold text-center text-black rounded-none h-[70px] w-[70px] z-20 `}
        >
          <figure className="flex shrink-0 self-stretch my-auto " />
          {businessAvatar ? (
            <div className="z-50 relative w-[70px] h-[70px] rounded-md overflow-hidden bg-gray-100 shadow-sm  ">
              <img
                src={`${process.env.REACT_APP_URL_IMAGE}/${businessAvatar}`}
                className="z-50 w-[70px] h-[70px] rounded-md object-cover"
                alt={fileName || ""}
              />
            </div>
          ) : (
            <img
              src={images.RetailStoreIcon}
              className="w-[70px] h-[70px] rounded-full object-scale-down"
              alt={fileName || ""}
            />
          )}
        </div>
      </div>
      <div className="flex flex-col gap-[18px] mt-12 w-full px-[32px]">
        <div className="flex flex-col gap-[6px]">
          <div className="flex justify-between items-start w-full">
            <div>
              <p
                className={`text-2xl font-bold ${
                  !isEnable ? "text-[#A0A0A0]" : "text-[#253FF6]"
                }`}
              >
                {questName}
              </p>
            </div>
            <Status
              className="mt-[6px]"
              isDisabled={!isEnable}
              status={
                numberHandleByQuota === 0 &&
                (quotaType === "DAILY" || quotaType === "WEEKLY")
                  ? "eligible"
                  : isEnable === false
                  ? "ineligible"
                  : slotAvailable === 0 && consumerStatus === "NOT_STARTED"
                  ? "full"
                  : consumerStatus === "NOT_STARTED"
                  ? "eligible"
                  : consumerStatus === "COMPLETED"
                  ? "completed"
                  : consumerStatus === "REVIEWING"
                  ? "review"
                  : consumerStatus === "SAVE_QUEST"
                  ? "saved"
                  : consumerStatus === "PAUSED_QUEST"
                  ? "paused"
                  : consumerStatus === "INELIGIBLE"
                  ? "ineligible"
                  : "eligible"
              }
            />
          </div>
          <div className="flex gap-1.5 items-center w-full">
            <p
              className={`text-base font-medium ${
                consumerStatus === "INELIGIBLE"
                  ? "text-[#A0A0A0]"
                  : "text-[#253FF6]"
              }`}
            >
              {questType === "INTRODUCE"}
              {questType === "USER_JOURNEY"}
              {questType === "PULSE_CHECK"}
              {questType === "SNAP"}
            </p>
          </div>
          <div className="flex gap-1.5 items-center w-full">
            <img
              src={
                questType === "INTRODUCE" || "USER_JOURNEY"
                  ? images.CalendarIcon
                  : images.CalendarDefault
              }
              alt="calendar-icon"
              className="h-[18px] w-[18px]"
            />
            <div className="text-base font-medium text-[#A0A0A0]">
              {questType === "SNAP" && <div>Available twice daily</div>}
              {questType === "PULSE_CHECK" && <div>Available weekly</div>}
              {questType !== "SNAP" && questType !== "PULSE_CHECK" && (
                <div>{timeInfo.display} left</div>
              )}
            </div>
          </div>
        </div>
        <div className="flex justify-between items-center w-full gap-[18px]">
          <QuestStatBox
            isDisabled={!isEnable}
            icon={
              !isEnable
                ? images.RallyCoinDisabled
                : images.RallyCoinSmallBlueIcon
            }
            label={t("quest.taskQuest.rallyCoins")}
            value={token}
            status={
              consumerStatus === "INELIGIBLE" ? "ineligible" : "rallycoins"
            }
          />
          <QuestStatBox
            isDisabled={!isEnable}
            icon={!isEnable ? images.ClockDisabled : images.Clock}
            label={t("quest.taskQuest.estDuration")}
            value={`${estTime} ${t("quest.taskQuest.mins")}`}
            status={consumerStatus === "INELIGIBLE" ? "ineligible" : "est"}
          />
          <QuestStatBox
            isDisabled={!isEnable}
            icon={
              quotaType === "DAILY" || quotaType === "WEEKLY"
                ? images.DailyQuota
                : !isEnable
                ? images.User03Disabled
                : images.User03
            }
            label={
              quotaType === "DAILY"
                ? t("quest.taskQuest.dailyQuota")
                : quotaType === "WEEKLY"
                ? t("quest.taskQuest.weeklyQuota")
                : t("quest.taskQuest.slotsLeft")
            }
            value={
              quotaType === "DAILY" || quotaType === "WEEKLY"
                ? `${numberHandleByQuota} / ${quotaCount}`
                : slotAvailable
            }
            status={
              (quotaType === "DAILY" || quotaType === "WEEKLY") &&
              numberHandleByQuota === quotaCount
                ? "dailyQuotaLeft"
                : consumerStatus === "INELIGIBLE"
                ? "ineligible"
                : questType === "SNAP"
                ? "highlight"
                : slotAvailable === slotLeft
                ? "slotleft"
                : "highlight"
            }
            isSlot
          />
        </div>
        <div>
          <Requirement
            title="Requirement"
            body={requirement}
            isIneligible={isIneligible}
            isEnable={isEnable}
          />
        </div>
        <div>
          {/* {<>{countdown}</>} */}

          {consumerStatus === "PAUSED_QUEST" &&
            remainingTime !== null &&
            remainingTime > 0 && (
              <Timer
                time={remainingTime}
                isStatic={true}
                className="rounded-md"
              />
            )}
          {
            (quotaType === "DAILY" || quotaType === "WEEKLY") &&
            numberHandleByQuota === quotaCount ? (
              <>
                {quotaType === "WEEKLY" && (
                  <div className="w-full text-center py-2 rounded-md pointer-events-none bg-[#E9E6E4] text-[#A0A0A0] text-xl font-medium">
                    {countdown}
                  </div>
                )}
                {quotaType === "DAILY" && (
                  <div className="w-full text-center py-2 rounded-md pointer-events-none bg-[#E9E6E4] text-[#A0A0A0] text-xl font-medium">
                    {countdownDay}
                  </div>
                )}
              </>
            ) : (
              <>
                {numberHandleByQuota !== quotaCount &&
                questType === "SNAP" &&
                isEnable === true ? (
                  <Button
                    text={"Start Quest!"}
                    onClick={handleTaskQuest}
                    className={cn(
                      "w-full font-bold py-3 rounded-md text-white bg-[#253FF6]"
                    )}
                  />
                ) : (
                  <Button
                    text={isEnable ? text : "Ineligible"}
                    onClick={
                      questType !== "SNAP" &&
                      (consumerStatus === "COMPLETED" ||
                        consumerStatus === "REVIEWING" ||
                        isEnable === false)
                        ? null
                        : handleTaskQuest
                    }
                    className={cn(
                      "w-full font-bold py-3 rounded-md",
                      color,
                      textColor,
                      isEnable
                        ? ""
                        : "  pointer-events-none bg-[#E9E6E4] text-[#A0A0A0] text-xl font-medium"
                    )}
                    disabled={!isEnable || disabled}
                  />
                )}
              </>
            )

            // (

            // <Button
            //   text={isEnable ? text : "Ineligible"}
            //   onClick={
            //     questType !== "SNAP" &&
            //     (consumerStatus === "COMPLETED" ||
            //       consumerStatus === "REVIEWING" ||
            //       isEnable === false)
            //       ? null
            //       : handleTaskQuest
            //   }
            //   className={cn(
            //     "w-full font-bold py-3 rounded-md",
            //     color,
            //     textColor,
            //     isEnable
            //       ? ""
            //       : "  pointer-events-none bg-[#E9E6E4] text-[#A0A0A0] text-xl font-medium"
            //   )}
            //   disabled={!isEnable || disabled}
            // />
            // )
          }

          <div className="w-full bg-[#E9E6E4] border mt-9"></div>
        </div>
      </div>
    </div>
  );
};

export default TaskQuest;
